export default __webpack_public_path__ + "static/media/tag-icon-strength.f32e0268.svg";